import styled from 'styled-components';

import { media } from '@/styles/mediaQuery';

export const TabList = styled.div`
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  border-bottom: solid 1px #ccc;
`;

export const TabButton = styled.button<{ selected?: boolean }>`
  padding: 0 1rem;
  height: 3.5rem;
  font-size: 1rem;
  font-weight: 600;
  background-color: transparent;
  border: none;
  color: ${(props) => (props.selected ? '#222' : '#A9AFC0')};
  border-bottom: solid 2px ${({ selected, theme }) => (selected ? theme.primary : '#fff')};

  ${media.tablet`
    padding: 0 0.5rem;
    font-size: 0.875rem;
  `}
`;
